import { Box, Stack, Typography } from "@mui/material";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { BanksList } from "Components/Shared/BanksList/BanksList";
import { PaperTitle } from "Components/Shared/PaperTitle";
import type { BankEnvironment } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { InfoBox } from "Components/Shared/InfoBox/InfoBox";

const ComponentResources = Resources.Banking.Auth;

type Props = {
  onBankSelected: (environment: BankEnvironment) => void;
  isPending: boolean;
  selectedEnvironment?: BankEnvironment | null;
};

export const BankConnectionList = ({
  onBankSelected,
  isPending,
  selectedEnvironment,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={4}>
      <PaperTitle>
        {t(Resources.Onboarding.BusinessOnboarding.Steps.BankAccount.Title)}
      </PaperTitle>
      <Typography>{t(Resources.Banking.Auth.Description)}</Typography>
      <Stack gap={2}>
        <InfoBox
          variant="info"
          content={t(ComponentResources.BankConnectionInfo)}
        />
        <InfoBox
          variant="warning"
          content={t(ComponentResources.BankConnectionWarning)}
        />
      </Stack>
      <BanksList
        actionType="add"
        onSelect={onBankSelected}
        pendingEnvironment={isPending ? selectedEnvironment : undefined}
        bankFilter="enabledOnly"
      />
      <UnstyledLink to={appUrl("bank-connection-ranking")}>
        <Typography
          display="flex"
          gap={1}
          alignItems="center"
          justifyContent="center"
        >
          <OpenInNewOutlinedIcon sx={{ fontSize: "0.9rem" }} />
          {t(Resources.BankRating.Title)}
        </Typography>
      </UnstyledLink>
      <Box mt={5}>
        <Typography>
          {t(
            Resources.Onboarding.BusinessOnboarding.Steps.BankAccount
              .BanksComingSoon,
          )}
        </Typography>
      </Box>
      <BanksList
        actionType="add"
        onSelect={onBankSelected}
        pendingEnvironment={isPending ? selectedEnvironment : undefined}
        bankFilter="disabledOnly"
        isExpandable
      />
    </Stack>
  );
};
